import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { CookiePreferencesComponent } from '../cookie-preferences/cookie-preferences.component';
import { FooterComponent } from './footer.component';

/**
 * The page footer and the cookie dialog it opens, on their own, so a lazy feature
 * module can pick them up without pulling in all of `ComponentsModule` (settings
 * forms, the KPI matrix, the file uploader) for the sake of one strip of links.
 *
 * `ComponentsModule` re-exports it, so pages that already reach the footer
 * through that module are unaffected.
 */
@NgModule({
    declarations: [FooterComponent, CookiePreferencesComponent],
    imports: [CommonModule, FormsModule, TranslateModule, ButtonModule, DialogModule, TagModule, ToggleSwitchModule],
    exports: [FooterComponent],
})
export class PageFooterModule {}
